"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateCampaignRequestToJSON = exports.UpdateCampaignRequestFromJSONTyped = exports.UpdateCampaignRequestFromJSON = exports.instanceOfUpdateCampaignRequest = void 0;
var runtime_1 = require("../runtime");
var CampaignStatus_1 = require("./CampaignStatus");
/**
 * Check if a given object implements the UpdateCampaignRequest interface.
 */
function instanceOfUpdateCampaignRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateCampaignRequest = instanceOfUpdateCampaignRequest;
function UpdateCampaignRequestFromJSON(json) {
    return UpdateCampaignRequestFromJSONTyped(json, false);
}
exports.UpdateCampaignRequestFromJSON = UpdateCampaignRequestFromJSON;
function UpdateCampaignRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, CampaignStatus_1.CampaignStatusFromJSON)(json['status']),
    };
}
exports.UpdateCampaignRequestFromJSONTyped = UpdateCampaignRequestFromJSONTyped;
function UpdateCampaignRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'status': (0, CampaignStatus_1.CampaignStatusToJSON)(value.status),
    };
}
exports.UpdateCampaignRequestToJSON = UpdateCampaignRequestToJSON;
